// OpenLayersMapWithMarkers.js
import axios from 'axios'
import { Map, View } from 'ol'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import 'ol/ol.css'
import { fromLonLat } from 'ol/proj'
import { OSM, Vector } from 'ol/source'
import { Icon, Stroke, Style } from 'ol/style'
import VectorSource from 'ol/source/Vector'
import React, { useEffect, useState } from 'react'
import StartPoint from '../../../../assets/images/Surveillance/mapIconStartPoint.svg'
import EndPoint from '../../../../assets/images/Surveillance/mapIconEndPoint.svg'
import UserMarker from '../../../../assets/images/Surveillance/mapIconUser.svg'
import MotoMarker from '../../../../assets/images/Surveillance/mapIconMotocycle.svg'
import PrevixMarker from '../../../../assets/images/Surveillance/mapIconPrevix.svg'
import api from '../../../../services/api'
import { LineString } from 'ol/geom'
import './styles.css'

const MapTracking = ({ occurrence }) => {
  const [userLocation, setUserLocation] = useState()
  const [addressLocation, setAddressLocation] = useState()
  const [employeeLocation, setEmployeeLocation] = useState()
  const [occurrenceLocation, setOccurrenceLocation] = useState()

  const getOccurenceCoordinates = (occurrenceId) => {
    api
      .post('/v1/dashboard/surveillance/tracking', {
        occurrenceId,
      })
      .then((response) => {
        console.log('DETALHE DA OCORRENCIA DADOS:', response.data)
        console.log('ocorrencia', occurrence)

        setUserLocation(response.data.userLocation)
        if (response.data.addressLocation) {
          setAddressLocation(response.data.addressLocation)
        } else {
          setAddressLocation({ latitude: 0, longitude: 0 })
        }
        setEmployeeLocation(response.data.employeeLocation)
        setOccurrenceLocation(response.data.occurrenceLocation)
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      })
  }

  const getDirections = async (start, end) => {
    const apiKey = '5b3ce3597851110001cf62485355a2b433be4c7e85f41fa887277137'
    const url = 'https://api.openrouteservice.org/v2/directions/driving-car'
    
    // Check if start and end arrays have valid coordinates
    if (!start || !Array.isArray(start) || start.length < 2 || !end || !Array.isArray(end) || end.length < 2) {
      console.error('Invalid start or end coordinates:', { start, end })
      return []
    }
    
    const params = {
      api_key: apiKey,
      start: `${start[0]}, ${start[1]}`,
      end: `${end[0]}, ${end[1]}`,
      language: 'pt',
    }

    try {
      const response = await axios.get(url, {
        params,
      })
      
      // Check if response has valid features
      if (!response.data || !response.data.features || !Array.isArray(response.data.features) || response.data.features.length === 0) {
        console.error('Invalid response data:', response.data)
        return []
      }
      
      const coordinates = response.data.features[0].geometry.coordinates
      return coordinates.map((coord) => fromLonLat(coord))
    } catch (error) {
      console.error('Error fetching directions:', error)
      return []
    }
  }

  // Create a line feature based on OpenRouteService API result
  const createTrackFeature = async (startPoint, endPoint, map) => {
    const coordinates = await getDirections(startPoint, endPoint)
    if (coordinates.length > 0) {
      const track = new LineString(coordinates)
      const trackFeature = new Feature(track)
      const trackLayer = new VectorLayer({
        source: new Vector({
          features: [trackFeature],
        }),
        style: new Style({
          stroke: new Stroke({
            color: '#004273',
            width: 2,
          }),
        }),
      })
      map.addLayer(trackLayer)
    } else {
      console.warn('No route found')
    }
  }

  useEffect(() => {
    // Only fetch tracking data for non-closed occurrences
    if (occurrence.Occurrence.status !== "Fechado") {
      getOccurenceCoordinates(occurrence.Occurrence.id)
    }
  }, [occurrence.Occurrence.id, occurrence.Occurrence.status])

  useEffect(() => {
    // Create map layer based on occurrence type and status (aligned with backend logic)
    if (occurrence.Occurrence.type === 'Escolta') {
      // ESCOLTA logic based on backend
      if (occurrence.Occurrence.status === 'Em ocorrência' && employeeLocation && userLocation) {
        // EMPROGRESSO: Track between employee and resident
        const startPoint = [employeeLocation.longitude, employeeLocation.latitude]
        const endPoint = [userLocation.longitude, userLocation.latitude]

        // Calculate center between employee and resident
        const centerLon = (startPoint[0] + endPoint[0]) / 2
        const centerLat = (startPoint[1] + endPoint[1]) / 2
        const center = fromLonLat([centerLon, centerLat])

        const map = new Map({
          target: 'map',
          layers: [
            new TileLayer({
              source: new OSM(),
            }),
          ],
          view: new View({
            center,
            zoom: 10,
          }),
        })

        const markerLayer = new VectorLayer({
          source: new VectorSource(),
        })

        // Show employee marker (start point) - z-index: 2
        const markerEmployee = [
          {
            coordinates: fromLonLat(startPoint),
            icon: EndPoint,
            scale: 2.5,
            zIndex: 2,
          },
        ]

        // Show resident marker (destination) - z-index: 1
        const markerUser = [
          {
            coordinates: fromLonLat(endPoint),
            icon: StartPoint,
            scale: 1.5,
            zIndex: 1,
          },
        ]

        // Show actual employee marker - z-index: 4
        const markerEmployeeActual = [
          {
            coordinates: fromLonLat(startPoint),
            icon: MotoMarker,
            scale: 1.5,
            zIndex: 4,
          },
        ]

        // Show actual resident marker - z-index: 5
        const markerUserActual = [
          {
            coordinates: fromLonLat(endPoint),
            icon: UserMarker,
            scale: 1.5,
            zIndex: 5,
          },
        ]

        markerEmployee.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
              zIndex: marker.zIndex,
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        markerUser.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
              zIndex: marker.zIndex,
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        markerEmployeeActual.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
              zIndex: marker.zIndex,
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        markerUserActual.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
              zIndex: marker.zIndex,
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        // Create route from employee to resident
        createTrackFeature(startPoint, endPoint, map)

        map.addLayer(markerLayer)

        return () => {
          map.dispose()
        }
      } else if (occurrence.Occurrence.status === 'Aguardando ação' && userLocation && addressLocation) {
        // ABERTO: Track between resident and address
        const startPoint = [userLocation.longitude, userLocation.latitude]
        const endPoint = [addressLocation.longitude, addressLocation.latitude]

        // Calculate center between resident and address
        const centerLon = (startPoint[0] + endPoint[0]) / 2
        const centerLat = (startPoint[1] + endPoint[1]) / 2
        const center = fromLonLat([centerLon, centerLat])

        const map = new Map({
          target: 'map',
          layers: [
            new TileLayer({
              source: new OSM(),
            }),
          ],
          view: new View({
            center,
            zoom: 10,
          }),
        })

        const markerLayer = new VectorLayer({
          source: new VectorSource(),
        })

        // Show resident marker (start point) - z-index: 2
        const markerUser = [
          {
            coordinates: fromLonLat(startPoint),
            icon: EndPoint,
            scale: 1.5,
            zIndex: 2,
          },
        ]

        // Show destination marker (address) - z-index: 1
        const markerEndPoint = [
          {
            coordinates: fromLonLat(endPoint),
            icon: StartPoint,
            scale: 1.5,
            zIndex: 1,
          },
        ]

        // Show actual resident marker - z-index: 5
        const markerUserActual = [
          {
            coordinates: fromLonLat(startPoint),
            icon: UserMarker,
            scale: 1.5,
            zIndex: 5,
          },
        ]

        markerUser.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
              zIndex: marker.zIndex,
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        markerEndPoint.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
              zIndex: marker.zIndex,
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        markerUserActual.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
              zIndex: marker.zIndex,
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        // Create route from resident to address
        createTrackFeature(startPoint, endPoint, map)

        map.addLayer(markerLayer)

        return () => {
          map.dispose()
        }
      }
    } else if (occurrence.Occurrence.type === 'Pânico') {
      // PANICO logic based on backend
      if (occurrence.Occurrence.status === 'Em ocorrência' && employeeLocation && userLocation) {
        // EMPROGRESSO: Track between employee and resident
        const startPoint = [employeeLocation.longitude, employeeLocation.latitude]
        const endPoint = [userLocation.longitude, userLocation.latitude]

        // Calculate center between employee and resident
        const centerLon = (startPoint[0] + endPoint[0]) / 2
        const centerLat = (startPoint[1] + endPoint[1]) / 2
        const center = fromLonLat([centerLon, centerLat])

        const map = new Map({
          target: 'map',
          layers: [
            new TileLayer({
              source: new OSM(),
            }),
          ],
          view: new View({
            center,
            zoom: 10,
          }),
        })

        const markerLayer = new VectorLayer({
          source: new VectorSource(),
        })

        // Show employee marker
        const markerEmployee = [
          {
            coordinates: fromLonLat(startPoint),
            icon: MotoMarker,
            scale: 2.5,
          },
        ]

        // Show resident marker
        const markerUser = [
          {
            coordinates: fromLonLat(endPoint),
            icon: UserMarker,
            scale: 1.5,
          },
        ]

        markerEmployee.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        markerUser.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        // Create route from employee to resident
        createTrackFeature(startPoint, endPoint, map)

        map.addLayer(markerLayer)

        return () => {
          map.dispose()
        }
      } else if (userLocation) {
        // Show only resident position for other statuses
        const center = fromLonLat([
          userLocation.longitude,
          userLocation.latitude,
        ])

        const map = new Map({
          target: 'map',
          layers: [
            new TileLayer({
              source: new OSM(),
            }),
          ],
          view: new View({
            center,
            zoom: 12,
          }),
        })

        const markerLayer = new VectorLayer({
          source: new VectorSource(),
        })

        const markerUser = [
          {
            coordinates: center,
            icon: UserMarker,
            scale: 1.5,
            zIndex: 5,
          },
        ]

        markerUser.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
              zIndex: marker.zIndex,
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        map.addLayer(markerLayer)

        return () => {
          map.dispose()
        }
      }
    } else if (occurrence.Occurrence.type === 'Suspeita') {
      // SUSPEITA logic based on backend - no distance/duration calculation, only show locations
      if (userLocation) {
        const center = fromLonLat([
          userLocation.longitude,
          userLocation.latitude,
        ])

        const map = new Map({
          target: 'map',
          layers: [
            new TileLayer({
              source: new OSM(),
            }),
          ],
          view: new View({
            center,
            zoom: 12,
          }),
        })

        const markerLayer = new VectorLayer({
          source: new VectorSource(),
        })

        // Show occurrence location marker (base) - z-index: 3
        const markerOccurrence = [
          {
            coordinates: center,
            icon: PrevixMarker,
            scale: 1.5,
            zIndex: 3,
          },
        ]

        markerOccurrence.forEach((marker) => {
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src: marker.icon,
                scale: marker.scale,
              }),
              zIndex: marker.zIndex,
            }),
          )
          markerLayer.getSource().addFeature(feature)
        })

        // Show employee marker if available - z-index: 4
        if (employeeLocation) {
          const markerEmployee = [
            {
              coordinates: fromLonLat([
                employeeLocation.longitude,
                employeeLocation.latitude,
              ]),
              icon: MotoMarker,
              scale: 2.5,
              zIndex: 4,
            },
          ]

          markerEmployee.forEach((marker) => {
            const feature = new Feature(new Point(marker.coordinates))
            feature.setStyle(
              new Style({
                image: new Icon({
                  anchor: [0.5, 1],
                  src: marker.icon,
                  scale: marker.scale,
                }),
                zIndex: marker.zIndex,
              }),
            )
            markerLayer.getSource().addFeature(feature)
          })
        }

        map.addLayer(markerLayer)

        return () => {
          map.dispose()
        }
      }
    }

    // Fallback: Show occurrence location if no other conditions are met
    if (occurrenceLocation) {
      const center = fromLonLat([
        occurrenceLocation.longitude,
        occurrenceLocation.latitude,
      ])
      const map = new Map({
        target: 'map',
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
        view: new View({
          center,
          zoom: 10,
        }),
      })
      
      const markerOccurrence = [
        {
          coordinates: center,
          icon: StartPoint,
          scale: 1.5,
        },
      ]
      const markerLayer = new VectorLayer({
        source: new VectorSource(),
      })
      markerOccurrence.forEach((marker) => {
        const feature = new Feature(new Point(marker.coordinates))
        feature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0.5, 1],
              src: marker.icon,
              scale: marker.scale,
            }),
          }),
        )
        markerLayer.getSource().addFeature(feature)
      })
      map.addLayer(markerLayer)
      return () => {
        map.dispose()
      }
    }
  }, [
    occurrence,
    userLocation,
    addressLocation,
    employeeLocation,
    occurrenceLocation,
  ])

  // Show message for closed occurrences
  if (occurrence.Occurrence.status === "Fechado") {
    return (
      <div style={{ 
        width: '100%', 
        height: '300px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        borderRadius: '4px'
      }}>
        <p style={{ color: '#666', margin: 0 }}>Mapa não disponível para ocorrências encerradas</p>
      </div>
    )
  }

  return <div id="map" style={{ width: '100%', height: '300px' }}></div>
}

export default MapTracking
